import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { State } from 'store/state';
import { NeighborsWidget } from './NeighborsWidget';
import { demographicsSummarySelector } from '../demographics';
import { IDemographicsSummary } from 'store/state/selectors/insights/summaryTypes';

const dynamicContextTextSelector = createSelector(
  demographicsSummarySelector,
  (summary: IDemographicsSummary) => summary.length ? summary[0].text : ''
);

const mapStateToProps = (state: State) => ({
  dynamicContentText: dynamicContextTextSelector(state),
});

export default connect(mapStateToProps)(NeighborsWidget);
